// src/components/LoadingSpinner.tsx
// Spinner moderno unificado: anillo con gradiente que gira.
// - variant "brand": gradiente azul → verde (pantallas/secciones)
// - variant "white": blanco (para usar dentro de botones de color)
// Si no se pasa `label`, renderiza solo el anillo (ideal inline en botones).

import React from 'react';

interface LoadingSpinnerProps {
  size?: number;                    // px
  label?: string;                   // texto opcional debajo
  variant?: 'brand' | 'white';
  className?: string;
  thickness?: number;               // grosor del anillo en px
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 44,
  label,
  variant = 'brand',
  className = '',
  thickness = 5,
}) => {
  const ringMask = `radial-gradient(farthest-side, transparent calc(100% - ${thickness}px), #000 calc(100% - ${thickness}px))`;
  const background =
    variant === 'white'
      ? 'conic-gradient(from 90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.95) 70%, rgba(255,255,255,0) 100%)'
      : 'conic-gradient(from 90deg, rgba(59,130,246,0) 0%, #3b82f6 35%, #22c55e 75%, rgba(34,197,94,0) 100%)';

  const ring = (
    <div
      className="animate-spin rounded-full"
      style={{ width: size, height: size, background, WebkitMask: ringMask, mask: ringMask }}
    />
  );

  // Inline (sin label): solo el anillo, para botones u otros usos compactos.
  if (!label) {
    return (
      <span className={`inline-flex ${className}`} role="status" aria-label="Cargando">
        {ring}
      </span>
    );
  }

  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`} role="status" aria-label={label}>
      {ring}
      <p className="text-sm text-gray-500 font-medium">{label}</p>
    </div>
  );
};

export default LoadingSpinner;
